import 'babel-polyfill';
import React from 'react';
import axios from 'axios';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import store from 'store';
import config from 'config/config';
import App from 'containers/App';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import yellow from '@material-ui/core/colors/yellow';
import teal from '@material-ui/core/colors/teal';

//Configure Axios default values
axios.defaults.baseURL = config.apiUrl;

const target = document.getElementById('root');

const theme = createMuiTheme({
    palette: {
        primary: yellow,
        secondary: {
            ...teal,
            A400: "#33bcac"
        }
    },
	typography: {
		fontFamily: 'CamptonBook, Arial, sans-serif',
	},
});



render(
    <Provider store={store}>
        <MuiThemeProvider theme={theme}>            
			<App />
        </MuiThemeProvider>
    </Provider>,
    target
);



// WEBPACK FOOTER //
// ./src/index.js